import script from "./dottoriAggiuntiveEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./dottoriAggiuntiveEdit.vue?vue&type=script&setup=true&lang=ts"

import "./dottoriAggiuntiveEdit.vue?vue&type=style&index=0&id=7e060d09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e060d09"]])

export default __exports__